
import LayoutMixin from '@/mixins/layout'
import SupportTop from '@/components/page/support-top.vue'
import TermsNav from '@/components/page/terms-nav.vue'

export default {
  components: {
    SupportTop,
    TermsNav,
  },
  mixins: [LayoutMixin],
  async asyncData(content) {
    const { app } = content
    try {
      const res = await app.$API.support.getTermsOfUse({ type: 1 })
      return {
        termsList: res || [],
      }
    } catch (e) {
      return {
        termsList: [],
      }
    }
  },
  data() {
    return {
      htmlStr: '',
      termsList: [],
      initIndex: 0,
      title: this.$t(`navs.termsOfUse`),
    }
  },
  head() {
    return {
      title: this.title + this.$t('navs.suffixName'),
    }
  },
  mounted() {
    const hash = window.location.hash
    if (this.termsList.length) {
      if (hash) {
        let index = this.termsList.findIndex((item) => {
          return `#${item.code}` === hash
        })
        index = index === -1 ? 0 : index
        this.initIndex = index
      }
      this.handleItemClick(this.termsList[this.initIndex])
    }
  },
  methods: {
    handleItemClick(item) {
      this.htmlStr = item.content
      window.location.hash = `#${item.code}`
    },
  },
}
